import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { assign } from 'lodash';
import HierarchySelector from '../../HierarchySelector/HierarchySelector';
import { useSelector } from 'react-redux';

const mapBy = (array, idProp, childrenProp, path = '', division = 0) => {
	return array?.reduce((acc, item) => {
		const itemUid = item[idProp];
		acc[itemUid] = {
			...item,
			division: division || item.id,
			label: item.name,
			path: path ? `${path} > ${item.name}` : item.name,
		};

		const children = item[childrenProp]?.map((subItem) => ({
			...subItem,
			disabled: item.disabled,
			selected: true,
			checked: true,
		}));
		if (Array.isArray(children) && children.length > 0) {
			assign(
				acc,
				mapBy(
					children,
					idProp,
					childrenProp,
					// itemUid,
					acc[itemUid].path,
					division || item.id
				)
			);
		}
		return acc;
	}, {});
};

export const nestedIdExistsInMap = (nestedId, dataMap) => {
	if (!nestedId || !dataMap) return false;
	return !!dataMap[nestedId];
};

export const getFilterStates = (nestedIds, dataMap) => {
	const filters = {
		valid: [],
		invalid: [],
		disabled: [],
	};

	if (!nestedIds || !dataMap) {
		return filters;
	}

	nestedIds?.split(',').forEach((nestedId) => {
		const ids = nestedId.split('_');
		const rootId = ids[0];

		const isValidNestedId = nestedIdExistsInMap(nestedId, dataMap);
		if (isValidNestedId) {
			const data = dataMap[nestedId];
			const filter = {
				nestedId,
				parentId: data.parentId,
				level: +(ids.length - 1),
				name: data.name,
			};
			if (dataMap[rootId].disabled) {
				filters.disabled.push(filter);
			} else {
				filters.valid.push(filter);
			}
		} else {
			filters.invalid.push({ nestedId });
		}
	});

	return filters;
};

function HierarchySelectorWrapper({
	hierarchyFilterRhid,
	setSelectedHierarchy,
	hierarchySelections,
	updateHierarchySelections,
}) {
	const hierarchy = useSelector(
		(state) => state.fullCompanyViewReducer.hierarchy
	);
	const rhid = hierarchyFilterRhid;

	useEffect(() => {
		updateHierarchySelections(
			getFilterStates(rhid, mapBy(hierarchy, 'nestedId', 'subHierarchy')).valid
		);
	}, []);

	useEffect(() => {
		setSelectedHierarchy(hierarchySelections);
	}, [hierarchySelections]);
	const maxLevels = 3;

	const levelMetaData = [
		{ label: 'Departments' },
		{ label: 'Categories' },
		{ label: 'Sub Categories' },
	];

	return (
		<div id="HierarchySelectorContainer">
			<HierarchySelector
				data={hierarchy}
				maxLevels={maxLevels}
				onSelectionChange={updateHierarchySelections}
				selections={hierarchySelections}
				noRollup={false}
				levelMetaData={levelMetaData}
			/>
		</div>
	);
}

HierarchySelectorWrapper.propTypes = {
	hierarchyFilterRhid: PropTypes.string,
	setSelectedHierarchy: PropTypes.func,
	updateHierarchySelections: PropTypes.func,
	hierarchySelections: PropTypes.array,
};

export default HierarchySelectorWrapper;
